import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AccountAccessList from './components/AccountAccessList';

const { Cell } = ResponsiveGrid;

const AccountAccessSetting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="帳號磁扣設定"
        // description="公告事項"
        breadcrumbs={[
          {
            name: '帳號管理',
          },
          {
            name: '帳號磁扣設定',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AccountAccessList />
    </Cell>
  </ResponsiveGrid>
);

export default AccountAccessSetting;
